module.exports = __webpack_public_path__ + "img/iphone-map-FRANCE-fr.e6857ed3.webp";